import React, { useEffect, useState } from "react";
import "./HeroStyles.css";

import resume from "../../assets/documents/Resume Luis M-CT.pdf";

function Hero(props) {
  const isVideo = props.type === "video";
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const scrollTop = window.pageYOffset;
      if (scrollTop > 0 && !isScrolled) {
        setIsScrolled(true);
      } else if (scrollTop === 0 && isScrolled) {
        setIsScrolled(false);
      }
    }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled]);

  const heroClassName = `${props.cName} ${isScrolled ? "scrolled" : ""}`;

  const handleDownloadResume = () => {
    const link = document.createElement("a");
    link.href = resume;
    link.download = "Luis_Marquez_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={heroClassName}>
      {isVideo ? (
        <video className="video" src={props.src} autoPlay muted loop>
          Your browser does not support the video tag.
        </video>
      ) : (
        <img src={props.src} alt={props.alt} />
      )}
      <div className="hero-text">
        <h1>{props.title}</h1>
        <p>{props.text}</p>
        <a
          href={props.url}
          className={props.btnClass}
          onClick={handleDownloadResume}
        >
          {props.btnText}
        </a>
      </div>
    </div>
  );
}

export default Hero;
